import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { APP_ROUTES } from './app/app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideEnvironment } from 'src/app/providers/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideConstants } from 'src/app/providers/constants';
import { authInterceptor } from 'src/app/interceptors/auth.interceptor';
import { errorInterceptor } from 'src/app/interceptors/error.interceptor';
import { shopifyInterceptor } from 'src/app/interceptors/shopify.interceptor';
import { provideTranslateService } from '@ngx-translate/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule),
    provideRouter(APP_ROUTES),
    provideAnimations(),
    provideEnvironment({
      production: {
        frontDomain: 'https://goodchart.co',
        domain: 'https://brands.goodchart.co',
        server: 'https://back.goodchart.co',
        env: 'production',
        amplitudeKey: '9937ec9b9b4327fa400c9cdf2c8af71c',
      },
      staging: {
        frontDomain: 'https://staging.goodchart.co',
        domain: 'https://staging.brands.goodchart.co',
        server: 'https://staging.back.goodchart.co',
        env: 'staging',
        amplitudeKey: '',
      },
    }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, shopifyInterceptor])),
    provideAnimationsAsync(),
    provideConstants({
      AUTH_ROLE_KEY: 'goodchart-dashboard-role',
      AUTH_TOKEN_KEY: 'goodchart-dashboard-token',
      CONFIGURATION_ADMIN_HEADER: 'goodchart-admin-password',
      ADMIN_DASHBOARD_GRAPH_TYPES: [
        {
          key: 'view',
          label: 'Views',
        },
        {
          key: 'client',
          label: 'Clients',
        },
      ],
      DASHBOARD_GRAPH_TYPES: [
        {
          key: 'view',
          label: 'Views',
        },
        {
          key: 'cart',
          label: 'Carts',
        },
      ],
      APP_NAME: 'Goodchart',
      PLAN_ACTIVATION_USAGE_KEY: 'publishedChartLimit',
      SELECTED_THEME_KEY: 'goodchart-selected-theme',
    }),
    provideTranslateService({
      fallbackLang: 'en',
    }),
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 2500, horizontalPosition: 'end' },
    },
  ],
};
